export default "__VITE_ASSET__DPxkd7ON__"